import "./styles.css";

import { ApiError } from "@esp/api-client";
import { ToastProvider } from "@esp/ui";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";

import { createRouter } from "./app/router";
import { StaffProvider } from "./auth/StaffProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (count, error) => count < 2 && !(error instanceof ApiError && error.status >= 400 && error.status < 500),
    },
    mutations: { retry: false },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <StaffProvider>
          <RouterProvider router={createRouter()} />
        </StaffProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
